import { Anchor, type _Navigation } from ":shared/components/route";
import { default as routes } from "../routes";
import IdleIcon from "../assets/icons/calendar-idle.svg";
import ActiveIcon from "../assets/icons/calendar-active.svg";

export default function Agenda(props: _Navigation.SideNavJSXItemProps) {
  return (
    <Anchor
      class={props.anchor?.class}
      setup={{
        to: routes,
        classes: {
          active: `${props.anchor.setup.classes.active}`,
        },
      }}
      components={{
        title: "Agenda",
        idleIcon: <IdleIcon />,
        activeIcon: <ActiveIcon />,
      }}
    />
  );
}
